import classNames from 'classnames'
import { bool, func, shape, string } from 'prop-types'

import { PLACEHOLDER_URL } from 'shared/consts/marketplace/orders'
import Image from 'views/components/atoms/Image'
import { SuggestContentES_v3 as SuggestContentES } from 'views/utils/propTypes'
import { isRequired } from 'views/utils/propTypeUtils'

import './SearchBoxListItem.scss'

import SearchSuggestionName from './SearchSuggestionName'
import SearchSuggestionPrice from './SearchSuggestionPrice'

const SearchBoxListItem = ({
  mobile,
  item: {
    id,
    name,
    prices,
    deeplink,
    thumbnailURL,
    hasMultipleVariants,
    prescriptionMedicine,
  },
  queryStr,
  handleItemClick,
  highlighted,
  last,
}) => {
  const classList = classNames(
    'a-link a-link--no-underline o-SearchBox__item l-flex ',
    {
      'o-SearchBox__item--highlighted': highlighted,
      'u-border--bottom@medium o-SearchBox__item--border-bottom': !last,
    }
  )

  const productUrl = deeplink.indexOf('/', 0) === 0 ? deeplink : `/${deeplink}`
  const productThumbnailUrl = prescriptionMedicine
    ? PLACEHOLDER_URL
    : thumbnailURL

  return (
    <li
      key={`product-${id}`}
      data-product-id={id}
      data-qa-id="product-codes-list-in-suggest"
    >
      <a
        className={classList}
        href={productUrl}
        onClick={() => handleItemClick?.()}
        data-clientside-hook="SearchBoxListItemLink"
        data-qa-id="suggest-items"
      >
        <Image
          src={productThumbnailUrl}
          srcWidth={128}
          srcHeight={128}
          className="o-SearchBox__image u-border-radius u-background-color--background u-margin--right l-flex__fixed"
          alt={name}
        />
        <span
          data-qa-id="product-names-list-in-suggest"
          className="o-SearchBox__label l-flex__primary"
        >
          <SearchSuggestionName
            name={name}
            queryStr={queryStr}
            concat={mobile}
          />
        </span>
        <span className="u-margin--left l-flex__fixed">
          <div className="o-SearchBox__price a-h2 u-no-margin u-text-align--right u-text-align--left@small-tiny u-font-weight--normal u-no-wrap u-color--blue">
            <SearchSuggestionPrice
              prices={prices}
              hasMultipleVariants={hasMultipleVariants}
            />
          </div>
        </span>
      </a>
    </li>
  )
}

SearchBoxListItem.propTypes = {
  item: shape(isRequired(SuggestContentES)).isRequired,
  mobile: bool,
  queryStr: string,
  handleItemClick: func,
  highlighted: bool,
  last: bool,
}

SearchBoxListItem.defaultProps = {
  mobile: null,
  queryStr: null,
  handleItemClick: null,
  highlighted: false,
  last: true,
}

export default SearchBoxListItem
